<template>
  <div class="alert-cover-not-land-scape"
       :class="{'--no-event': isLandscape}">
    <div class="alert-cover-not-land-scape__inside">
      <div class="alert-cover-not-land-scape__content">
        <v-icon>screen_lock_portrait</v-icon>
        <p>画面を縦にしてご利用ください</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AlertCoverNotLandScape',
  data () {
    return {
      isLandscape: false
    }
  },
  created () {
    const that = this
    that.checkLandScape()
    window.addEventListener('resize', function () {
      that.checkLandScape()
    })
  },
  methods: {
    checkLandScape () {
      switch (window.orientation) {
        case 90:
        case -90:
          this.isLandscape = true
          break
        default:
          this.isLandscape = false
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .alert-cover-not-land-scape {
    color: #ffffff;
    font-size: x-large;
    font-weight: bold;
    display: none;
    &.--no-event {
      content: " ";
      position: fixed;
      top: 0;
      left: 0;
      display: block;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.7);
      pointer-events: none !important;
      z-index: 999;
    }
    & > .alert-cover-not-land-scape__inside {
      position: relative;
      width: 100vw;
      height: 100vh;
      & > .alert-cover-not-land-scape__content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateY(-50%) translateX(-50%);
        display: block;
        width: fit-content;
        height: fit-content;
        margin: auto;
        text-align: center;
        & /deep/ .icon {
          color: #ffffff;
          font-size: 5rem;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/atoms/AlertCoverNotLandScape.vue